<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <label for="emails">Emails (comma separated):</label>
    <textarea type="text" class="form-control" id="emails" formControlName="emails"></textarea>
  </div>
  <div class="form-group">
    <label for="type">Type:</label>
    <select class="custom-select" id="type" formControlName="type" (change)="changeType($event)">
      <option value=""> Select </option>
      @for (item of options; track item) {
        <option [value]="item">{{item}}</option>
      }
    </select>
  </div>
  <button type="submit" class="btn btn-primary">Submit</button>
  <button (click)="onCancel()" type="button" class="btn btn-secondary">Cancel</button>
</form>
